export const hapConfig = (employee) => {
  if (!employee.id) return null

  const identify = `${employee?.organization?.slug}_${employee?.id}`
  const userProperties = {
    'Emp Code': employee.code,
    'Emp Name EN': employee.name,
    'Emp Name AR': employee.name_ar,
    'Emp Job Title EN:': employee.job_title?.name,
    'Emp Job Title AR:': employee.job_title?.name_ar,
    'Slug:': employee.organization?.slug,
    'Company Name AR:': employee.organization?.name_ar,
    'Company Name EN:': employee.organization?.name,
    'Brand Name EN:': employee.organization?.brand_name,
    'Brand Name AR:': employee.organization?.brand_name_ar,
    'Industry:': employee.organization?.industry,
    'Tier:': employee.organization.tier,
    'Subscription Plan': employee.organization?.subscription_plan?.name,
  }

  window.heap?.identify(identify)
  window.heap?.addUserProperties(userProperties)

  return null
}
